var _defs, _circle, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsPatient(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 400 400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#000;stroke-miterlimit:10;stroke-width:8px;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 296,
    cy: 298,
    r: 94
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M195.5,224.5c-16,7-34,5-34,5-42.21-1.92-54-41.56-58.47-52.73a4.79,4.79,0,0,0-1.57-2c-21-15.71-21-30.41-22-41.23-.57-6.29,4.08-7.67,8.73-7.34A4.71,4.71,0,0,0,93.11,120c-7.47-22.23-5.88-45.23-5.64-48.14,0-.21,0-.4.09-.61,1-4.69,15.45-63.7,75.94-63.7,59.32,0,69.88,47.88,70.91,53.47a4.77,4.77,0,0,1,.08,1l-1.72,60.12a4.47,4.47,0,0,0,6.33,4.2h0a4.73,4.73,0,0,1,4.39.21c12,7.21,2.9,26.18-3.58,36.59a25.14,25.14,0,0,1-8.47,8.41,23.77,23.77,0,0,0-9.75,10.57,4.66,4.66,0,0,0-.3.89c-5.52,23.1-18.14,35.42-23.46,39.73a4.71,4.71,0,0,0-1.53,5.09c2,6.28,7.72,19.42,20.41,19.55"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.89,220.61,120.5,242.5s-116,20-111,81c1,48-6,64,16,69,15,0,263.56-.75,263.56-.75"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.82,244.75s18.35,76.79,95,30.27"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M236.91,126.69l-4.36,3c-7.87-46.91-14.8-50.84-19.79-55.46a4.18,4.18,0,0,0-5.85.21c-13.56,14.16-27.43,17-35.6,17.16a4.17,4.17,0,0,0-3.54,6.23c.87,1.52,1.8,3.14,2.7,4.67a4.18,4.18,0,0,1-3.49,6.3c-11.68.34-17.34-5.75-30.7-22.44a4.55,4.55,0,0,1-.48-.75C110.92,35.49,96,127.41,96,127.41l-3.58-3.15"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M343.5,289.87v20.26a4.37,4.37,0,0,1-4.37,4.37H313.37a3.37,3.37,0,0,0-3.37,3.37v25.76a4.37,4.37,0,0,1-4.37,4.37H285.37a4.37,4.37,0,0,1-4.37-4.37V317.87a3.37,3.37,0,0,0-3.37-3.37H251.87a4.37,4.37,0,0,1-4.37-4.37V289.87a4.37,4.37,0,0,1,4.37-4.37h25.76a3.37,3.37,0,0,0,3.37-3.37V256.37a4.37,4.37,0,0,1,4.37-4.37h20.26a4.37,4.37,0,0,1,4.37,4.37v25.76a3.37,3.37,0,0,0,3.37,3.37h25.76A4.37,4.37,0,0,1,343.5,289.87Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsPatient);
export default __webpack_public_path__ + "static/media/Icons_ Patient.e3e3e91df0814ea8efc5332ec61d7f9a.svg";
export { ForwardRef as ReactComponent };